<template>
  <div class="container">
    <div class="title">{{ $t('overall') }}</div>
    <div class="chart">
      <PieChart :options="chartOptions"></PieChart>
    </div>
    <div class="percentage">{{ progressText }}</div>
  </div>
</template>

<script>
import PieChart from '@wizer/core/components/chart/PieChart'

export default {
  name: 'OverallProgress',
  components: {
    PieChart,
  },
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    progressText() {
      return `${Math.round(this.percentage)}%`
    },
    chartOptions() {
      return {
        series: {
          color: [this.color, '#E5E7EB'],
          data: [this.percentage, 100 - this.percentage],
          label: false,
          radius: ['50%', '70%'],
          silent: true,
        },
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.container {
  @apply relative w-64 h-64 mt-10 -ml-6;
}
.title {
  @apply text-lg absolute ml-6 -mt-2;
}
.chart {
  @apply w-64 h-64;
}
.percentage {
  @apply absolute w-full text-4xl z-20 font-bold text-center;
  top: 40%;
}
</style>
